import script from "./UiSelectElement.js?vue&type=script&lang=js"
export * from "./UiSelectElement.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__